<section class="banner">
  <div #air id="air" class="air"></div>

  <app-nav class="w-100"></app-nav>
  <div class="head-component-ui">
    <div class="searchbar" data-aos="fade-down">
      <div class="hometitle mob-view pos-rel">
        <span class="sstarabicbold text-mobile-size search-txt">
          {{ "Knowledge portal" | translator }}
        </span>
        <span class="sstarabicbold">
          <div class="pi pi-times-circle" routerLink="/home" style="cursor: pointer"></div>

          <i class="fa fa-book me-2 p-1" style="font-size: 2rem" aria-hidden="true"></i>
          {{ "Knowledge Library" | translator }}
        </span>
      </div>

      <div class="">
        <div class="" style="position: relative">
          <form (ngSubmit)="handleSubmit($event)">
            <span class="p-input-icon-right w-100">
              <i class="pi pi-search" style="margin-right: 10px; width: 30px"></i>
              <input pInputText name="search"
                class="form-control header-input-ui form-control-lg px-5 shadow-sm sstarabicbold" type="text" dir="rtl"
                filterButton [(ngModel)]="filters.search" (ngModelChange)="filters.search = $event;handleFilter()"
                placeholder="{{ 'Research' | translator }}" />
            </span>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="knowledgeLibrarySection container-fluid" #target *ngIf="!preloader">
  <div class="container max-width-1700">
    <div class="row px-2" *ngIf="kLibrary.length > 0 || filteredData.length > 0">
      <div class="col-md-3 col-12 d-flex flex-column my-2 gap-2 bg-whitee py-4 border-8">
        <div class="col-12 col-md-12 d-flex justify-content-start gap-2 pb-2">
          <button [disabled]="!filterApplied" class="ms-library disable" icon="pi pi-rotate-right"
            (click)="clearFilter()">
            {{ "Reset" | translator }}
          </button>
          <div class="col-4">
            <button [pTooltip]="'Show Style' | translator" class="ms-library" (click)="viewaslist = !viewaslist">
              <i class="{{
                  viewaslist ? 'fa-solid fa-table-cells-large' : 'pi pi-list'
                }}"></i>
            </button>
          </div>
        </div>
        <div class="col-12 col-md-12 ppp-calander">
          <p-calendar styleClass="w-100 h-100" class="v4-calander" [(ngModel)]="filters.date"
            (ngModelChange)="filters.date = $event;handleFilter()" [showIcon]="true" selectionMode="range"
            [readonlyInput]="true" placeholder="{{ 'Date' | translator }}" [inputStyle]="{ 'text-align': 'right' }"
            filterButton dir="ltr"></p-calendar>
        </div>
        <!--  -->
        <div class="col-12 col-md-12 ppp-dropdown">
          <p-dropdown styleClass="w-100 h-100" [options]="availableExtensions" [(ngModel)]="filters.extension"
            (ngModelChange)="filters.extension = $event;handleFilter()"
            placeholder="{{ 'Types of files' | translator }}" filterButton></p-dropdown>
        </div>
        <!--  -->
        <div class="col-12 col-md-12 pb-2 ppp-dropdown">
          <p-dropdown styleClass="w-100 h-100" [(ngModel)]="filters.ou" optionLabel="name"
            (ngModelChange)="filters.ou = $event;handleFilter()" [options]="availableOus"
            placeholder="{{ 'Choose an organizational unit' | translator }}" [filter]="true" filterButton>
            <ng-template let-node pTemplate="default">
              <div class="d-flex">
                <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                  class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                <ng-template #elseBlock>
                  <i class="{{ node.image }} p-2" style="font-size: 1rem"></i>
                </ng-template>
                <b class="text-nowrap">{{ node.name }}</b>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <h5 class="text-start btn-sbc mx-2">
          {{ "Categories" | translator }}&nbsp;<i class="fa fa-chevron-circle-down"></i>
        </h5>
        <a class="w-100 decoration-none" *ngFor="let category of filterCategories; let i = index"
          (click)="handleCategoryFilter(category)">
          <button class="decoration-none w-100 d-flex gap-2 text-decoration-none justify-content-center {{
              category == currentCategory ? 'ms-btnn' : 'ppp-ms'
            }}">
            <i class="{{ category.icon }} text-decoration-none" aria-hidden="true"></i>

            <span>{{ checkarabic(category.name) }}</span>
            <span>({{ this.categoryCount[category.name] ?? 0 }})</span>
          </button>
        </a>
      </div>
      <div class="col-md-9 col-12">
        <div class="row" *ngIf="!viewaslist; else listView">
          <div class="col-lg-3 col-md-6 col-sm-6 col-12 hover-card my-2" role="button" (click)="handleSelect(item)"
            *ngFor="let item of filteredData">
            <div class="px-1">
              <!-- custom card  -->
              <div class="card card-shaddow card-bg-v4">
                <div class="headerr">
                  <img class="icon-img" src="{{ staticURL + item.image }}" />
                  <div class="heading mx-2">
                    <h6 class="title" [pTooltip]="item.name">
                      {{
                      item.name.length > 22
                      ? item.name.substring(0, 22) + "..."
                      : item.name
                      }}
                    </h6>
                    <p class="description">{{ item.categoryname }}</p>
                  </div>
                </div>
                <div class="img">
                  <img class="center-img" alt="" src="{{ staticURL + item.image }}" />
                </div>
                <div class="crd-footer px-2 py-2">
                  <a class="my-2 deco" [innerHTML]="item.description.substring(0, 28) + '...'"></a>
                  <span class="description-date my-2">{{
                    item.createdAt | date
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- TODO: List View Goes Here -->
        <ng-template #listView>
          <!-- <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-6 col-12 hover-card my-2" role="button" (click)="handleSelect(item)"
              *ngFor="let item of searchApplied ? filteredData : kLibrary">
              <div class="px-1">
                <div class="card card-shaddow card-bg-v4">
                  <div class="headerr-2">
                    <div class="heading mx-2">
                      <h6 class="title">
                        {{
                        item.name.length > 22
                        ? item.name.substring(0, 22) + "..."
                        : item.name
                        }}
                      </h6>
                      <hr />
                      <div class="row">
                        <div class="col p-0">
                          <div class="d-flex align-items-center mx-2">
                            <img class="icon-img-3" src="{{ staticURL + item.image }}" />
                            <p class="description m-0">
                              {{ item.categoryname }}
                            </p>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                    <img class="icon-img-2" src="{{ staticURL + item.image }}" alt="loading..." />
                  </div>
                  <div class="crd-footer px-2 pb-2">
                    <a class="my-2 deco" [innerHTML]="
                        item.description.length > 28
                          ? item.description.substring(0, 28) + '...'
                          : item.description
                      "></a>
                    <span class="description-date my-2">{{
                      item.createdAt | date
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- table START -->
          <div class="users-data-table d-flex justify-content-center container-fluid p-0">
            <div class="white-box container-fluid mb-2 p-0">
              <div class="grey-box">
                <table class="w-100">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">{{ "Data label" | translator }}</th>
                      <th scope="col">{{ "KL category" | translator }}</th>
                      <th scope="col">{{ "KL Description" | translator }}</th>
                      <th scope="col">{{ "Date" | translator }}</th>
                      <th scope="col">{{ "Action" | translator }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of filteredData">
                      <td style="width: 0px !important; background: transparent">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="d-flex tab-num-border-white">
                            <div class="tabel-detail-box">
                              <div class="ms-tabel-num-box">
                                <img class="tab-img" src="{{ staticURL + item.image }}" alt="loading" />
                              </div>
                            </div>
                          </div>
                        </span>
                      </td>
                      <td data-label="Main Criteria">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span [pTooltip]="item.name" class="tab-scroll">{{ item.name }}</span>
                          </div>
                        </span>
                      </td>
                      <td data-label="Sub Criteria">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll">{{
                              item.categoryname
                              }}</span>
                          </div>
                        </span>
                      </td>
                      <td data-label="Factor">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll" [innerHTML]="
                                item.description.length > 100
                                  ? item.description.substring(0, 28) + '...'
                                  : item.description
                              "></span>
                          </div>
                        </span>
                      </td>

                      <td data-label="Factor">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll">{{
                              item.createdAt | date
                              }}</span>
                          </div>
                        </span>
                      </td>

                      <td data-label="Options">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <!-- <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3"> -->
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              <div pTooltip="{{ 'View' | translator }}" tooltipPosition="top"
                                (click)="handleSelect(item)" class="tabel-circle-btn">
                                <i class="pi pi-eye"></i>
                              </div>
                            </div>
                          </div>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- <div class="flex justify-content-center">
              <p-paginator></p-paginator>
            </div> -->
            </div>
          </div>

          <!-- Table END -->
        </ng-template>
      </div>
    </div>
  </div>
  <app-no-data *ngIf="!preloader && kLibrary.length == 0"></app-no-data>
</section>

<app-skelitions [hidden]="!preloader" [value]="4"></app-skelitions>
<section class="faqsection" *ngIf="hasAnyKLibraryPermission()">
  <h1 class="sstarabicbold" style="color: white">
    <i class="fa fa-question-circle-o" aria-hidden="true"></i>
    {{ "Knowledge Library Content Management" | translator }}
  </h1>

  <p class="sstarabic mobile-text" style="color: white; padding: 10px 18px">
    {{
    "Add | Edit | Delete" | translator
    }}
  </p>

  <button class="btn v4-btn-every-border sstarabicbold" routerLink="/dashboard/knowledge-library"
    style="padding: 12px 22px">
    {{ "Press here" | translator }}
  </button>
</section>

<!-- Download Dialog -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="showDownload"
  [style]="{ width: '95vw', maxWidth: '1400px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ selectedItem.name }}</span>
  </ng-template>
  <div class="row" style="height: 80vh">
    <div class="col-md-4 col-12 col-4-ui">
      <div style="display: flex; gap: 5px; align-items: center">
        <i class="{{ selectedItem.categoryicon }}"></i>
        <p class="mb-1">{{ selectedItem.categoryname }}</p>
      </div>
      <p [innerHTML]="selectedItem.description"></p>
      <img alt="Image" src="{{ staticURL + selectedItem.image }}" style="max-height: 50px; max-width: 50px" />
      <p>
        {{ selectedItem.createdDate | date }}
      </p>
      <hr class="hr" />
      <div class="mr-1rem">
        <div role="button" (click)="handleChangeLink(file)" class="hover-card d-flex flex-row align-items-center w-100 border border-help rounded-3 px-3 mb-1 {{
            file == selectedLink ? 'v4-actived' : ''
          }}" style="gap: 5px" *ngFor="let file of selectedItem.link">
          <i class="{{ getFileIcon(file.link) }} {{
              file == selectedLink ? 'text-lightt' : ''
            }}"></i>
          <p class="mt-2 text-nowrap overflow-hidden text-truncate {{
              file == selectedLink ? 'text-lightt' : ''
            }}">
            {{ file.name }}
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="selectedLink != null && selectedLink != undefined"
      class="col-md-8 col-12 d-flex align-items-center justify-content-center flex-column gap-5">
      <div *ngIf="showingimage" class="w-100 h-100 d-flex justify-content-center">
        <img class="modal-imgg" src="{{ showingimagelink }}" alt="loading..." />
      </div>
      <div #parent *ngIf="playingYoutubeVideo && youtubeVideoId != null" style="width: 100%; height: 65vh">
        <youtube-player [height]="parent.clientHeight" [width]="parent.clientWidth" [videoId]="youtubeVideoId"
          (ready)="savePlayer($event)" (change)="onStateChange($event)">
        </youtube-player>
      </div>
      <div *ngIf="playingvideo" class="player-wrapper w-100" dir="ltr">
        <video *ngIf="videolink" class="w-100" style="width: 100%; height: 65vh" controls>
          <source [src]="videolink" type="video/{{ videoExtension }}" />
          {{ "Your browser does not support this type of video" | translator }}
        </video>
      </div>
      <div *ngIf="showingpdf" class="w-100 h-100">
        <object [data]="showPdf()" type="application/pdf" style="
            width: 100%;
            height: 65vh;
            display: block;
            border-top: #525659 solid 5px;
            border-bottom: #525659 solid 5px;
          ">
          <a [href]="staticURL + selectedLink.link">{{
            "Download file.pdf" | translator
            }}</a>
        </object>
      </div>

      <!-- <div *ngIf="showingppt">
        <iframe 
          *ngIf="showpptlink"
          [src]="showpptlink"
          style="
            width: 100%;
            height: 65vh;
            display: block;
            border-top: #525659 solid 5px;
            border-bottom: #525659 solid 5px;
          ">
        </iframe>
      
        <p *ngIf="loading">Loading...</p>
      </div> -->

      <i [hidden]="
          playingvideo ||
          showingpdf ||
          showingimage ||
          playingYoutubeVideo
        " class="{{ getFileIcon(selectedLink.link) }}" style="font-size: 200px"></i>
      <div class="d-flex custom-flex-column my-2 gap-2 outlined">
        <a *ngIf="!pdfloading" [href]="staticURL + selectedLink.link" target="_blank">
          <button class="v4-btn-every py-2">
            <i class="pi pi-folder" aria-hidden="true"></i>{{ "Open in new tab" | translator }}
          </button>
        </a>
        <button class="v4-btn-every py-2" (click)="downloadFile(selectedLink)">
          <i class="pi pi-download v4-ml-2"></i>{{ "download file" | translator }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<app-footer></app-footer>